// Copyright Abridged, Inc. 2021,2024. All Rights Reserved.
// Node module: @collabland/sdk
// This file is licensed under the MIT License.
// License text available at https://opensource.org/license/mit/

import {model, property} from '@loopback/repository';
import {Channel} from './channel.model.js';
import {Quest} from './quest.model.js';
import {Drop} from './drop.model.js';
import {Stats} from './stats.model.js';
import {TokenPermissionedChat} from './token-permissioned-chat.model.js';

/**
 * The model class is generated from OpenAPI schema - CommunityPartial
 * (tsType: Partial<Community>, schemaOptions: { partial: true })
 */
@model({name: 'CommunityPartial'})
export class CommunityPartial {
  constructor(data?: Partial<CommunityPartial>) {
    if (data != null && typeof data === 'object') {
      Object.assign(this, data);
    }
  }

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  id?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  createdTime?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  pk?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  sk?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  classifier?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  classifierGroup?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  name?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  status?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  communityId?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  ownerId?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  adminUserId?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  platform?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  link?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  serverImage?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  welcomeMessage?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  network?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  cashtag?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  tokenAddress?: string;

  /**
   *
   */
  @property.array(String, {
    jsonSchema: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  })
  admins?: string[];

  /**
   *
   */
  @property.array(String, {
    jsonSchema: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  })
  activePlans?: string[];

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  iconURL?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  inviteLink?: string;

  /**
   *
   */
  @property.array(Channel, {
    jsonSchema: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/Channel',
      },
    },
  })
  channels?: Channel[];

  /**
   *
   */
  @property.array(Quest, {
    jsonSchema: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/Quest',
      },
    },
  })
  quests?: Quest[];

  /**
   *
   */
  @property.array(Drop, {
    jsonSchema: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/Drop',
      },
    },
  })
  drops?: Drop[];

  /**
   *
   */
  @property({
    jsonSchema: {
      $ref: '#/components/schemas/Stats',
    },
  })
  stats?: Stats;

  /**
   *
   */
  @property.array(TokenPermissionedChat, {
    jsonSchema: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/TokenPermissionedChat',
      },
    },
  })
  tpcs?: TokenPermissionedChat[];

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'boolean',
    },
  })
  disableBkgBalCheck?: boolean;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'boolean',
    },
  })
  disablePromotionalUpdates?: boolean;

  /**
   * additionalProperties
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [additionalProperty: string]: any;
}

export interface CommunityPartialRelations {
  // describe navigational properties here
}

export type CommunityPartialWithRelations = CommunityPartial &
  CommunityPartialRelations;
